import React from "reactn";

import PropTypes from "prop-types";

// styled components
import ProductItemStyled from "./ProductItem.styled";

const ProductItem = props => {
    const { values, id, name } = props;
    return (
        <ProductItemStyled>
            <p>{name}</p>
            <p>{values[id]}</p>
            <input
                type="hidden"
                name={id}
                key={id}
                value={values[id]}
            />
        </ProductItemStyled>
    );
};

ProductItem.propTypes = {
    values: PropTypes.array,
    id: PropTypes.string,
    name: PropTypes.string
};

export default ProductItem;
